import { render, staticRenderFns } from "./TheAuthBox.vue?vue&type=template&id=f90d8fa8&scoped=true&"
import script from "./TheAuthBox.vue?vue&type=script&lang=js&"
export * from "./TheAuthBox.vue?vue&type=script&lang=js&"
import style0 from "./TheAuthBox.vue?vue&type=style&index=0&id=f90d8fa8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90d8fa8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardActions,VCardText,VSpacer,VTab,VTabItem,VTabs,VTextField})
